/**
 * Frontegg activation config (G2 front door).
 *
 * The hosted-login front door turns on only when the deploy provides both
 * env vars (render.yaml injects them for production). Without them the app
 * runs in legacy mode — no provider, no guard, localStorage tokens — which
 * keeps local dev, vitest, and the Playwright e2e (which stub the API and
 * never authenticate) working unchanged.
 */

export const FRONTEGG_BASE_URL: string | undefined = import.meta.env
  .VITE_FRONTEGG_BASE_URL;
export const FRONTEGG_CLIENT_ID: string | undefined = import.meta.env
  .VITE_FRONTEGG_CLIENT_ID;

export const fronteggEnabled: boolean = Boolean(
  FRONTEGG_BASE_URL && FRONTEGG_CLIENT_ID
);
